import { useEffect } from 'react';

import { useAppDispatch } from 'store/useAppDispatch';

import {
  IUsePersonalAccountJWTProps,
  usePersonalAccountJWT,
} from './usePersonalAccountJWT';
import {
  setUserEndpointToken,
  setWorkerToken,
} from '../store/personalAccountSlice';
import { usePersonalAccountState } from './usePersonalAccountState';

export interface UseInitPersonalAccountProps
  extends IUsePersonalAccountJWTProps {}

export const useInitPersonalAccount = ({
  skipFetching,
}: UseInitPersonalAccountProps = {}) => {
  const { isInitialized } = usePersonalAccountState();

  const { personalAccountJWT } = usePersonalAccountJWT({
    skipFetching: skipFetching || isInitialized,
  });

  const dispatch = useAppDispatch();

  const { workerTokenData } = personalAccountJWT;
  const userEndpointToken = workerTokenData?.userEndpointToken;
  const workerToken = workerTokenData?.signedToken;

  useEffect(() => {
    if (userEndpointToken) {
      dispatch(setUserEndpointToken(userEndpointToken));
    }
  }, [dispatch, userEndpointToken]);

  useEffect(() => {
    if (workerToken) {
      dispatch(setWorkerToken(workerToken));
    }
  }, [dispatch, workerToken]);
};
